// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ssXA0ndVdcN_Z37y3vVw {
  display: flex;
  gap: 40px;
  background-color: var(--grey-color-10);
  margin: 16px 0;
  padding: 16px 0;
  border-radius: 10px;
}

.DAWNBZS32tls6htJpknJ {
  padding-top: 8px;
  padding-left: 8px;
  float: left;
}

.tlJ4ZJqC0QQgXF8ts9To {
  flex: 3;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
  max-width: 420px;
}

.ZOMo2WIKeRUcEi4r7Got {
  flex: 7;
  background-color: var(--background-color);
  padding: 32px;
  border-radius: 10px;
  width: 100%;
}

.P5bRWUg65W4NS3ZPymsA {
  margin-top: 100px;
}`, "",{"version":3,"sources":["webpack://./src/components/DistributionBarSet/DistributionBarSet.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,OAAA;EACA,yCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".chartContainer {\n  display: flex;\n  gap: 40px;\n  background-color: var(--grey-color-10);\n  margin: 16px 0;\n  padding: 16px 0;\n  border-radius: 10px;\n}\n\n.chartTitle {\n  padding-top: 8px;\n  padding-left: 8px;\n  float: left;\n}\n\n.piChartContainer {\n  flex: 3;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n  max-width: 420px;\n}\n\n.barChartContainer {\n  flex: 7;\n  background-color: var(--background-color);\n  padding: 32px;\n  border-radius: 10px;\n  width: 100%;\n}\n\n.donutChartInner {\n  margin-top: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `ssXA0ndVdcN_Z37y3vVw`,
	"chartTitle": `DAWNBZS32tls6htJpknJ`,
	"piChartContainer": `tlJ4ZJqC0QQgXF8ts9To`,
	"barChartContainer": `ZOMo2WIKeRUcEi4r7Got`,
	"donutChartInner": `P5bRWUg65W4NS3ZPymsA`
};
export default ___CSS_LOADER_EXPORT___;
